import { createGlobalStyle } from 'styled-components'

import DINNextLight from 'assets/fonts/DINNextLTPro/DINNextLTPro-Light.otf'
import DINNextLightItalic from 'assets/fonts/DINNextLTPro/DINNextLTPro-LightItalic.otf'
import DINNextRegular from 'assets/fonts/DINNextLTPro/DINNextLTPro-Regular.otf'
import DINNextItalic from 'assets/fonts/DINNextLTPro/DINNextLTPro-Italic.otf'
import DINNextMedium from 'assets/fonts/DINNextLTPro/DINNextLTPro-Medium.otf'
import DINNextMediumItalic from 'assets/fonts/DINNextLTPro/DINNextLTPro-MediumItalic.otf'
import DINNextBold from 'assets/fonts/DINNextLTPro/DINNextLTPro-Bold.otf'
import DINNextBoldItalic from 'assets/fonts/DINNextLTPro/DINNextLTPro-BoldItalic.otf'
import DINNextHeavy from 'assets/fonts/DINNextLTPro/DINNextLTPro-Heavy.otf'
import DINNextHeavyItalic from 'assets/fonts/DINNextLTPro/DINNextLTPro-HeavyItalic.otf'
import DINNextBlack from 'assets/fonts/DINNextLTPro/DINNextLTPro-Black.otf'
import DINNextBlackItalic from 'assets/fonts/DINNextLTPro/DINNextLTPro-BlackItalic.otf'
import DINNextUltraLight from 'assets/fonts/DINNextLTPro/DINNextLTPro-UltraLight.otf'
import DINNextUltraLightItalic from 'assets/fonts/DINNextLTPro/DINNextLTPro-UltraLightIt.otf'

const MladinskaFonts = createGlobalStyle`
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextUltraLight}) format('opentype');
    font-weight: 200;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextUltraLightItalic}) format('opentype');
    font-weight: 200;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextLight}) format('opentype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextLightItalic}) format('opentype');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextRegular}) format('opentype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextItalic}) format('opentype');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextMedium}) format('opentype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextMediumItalic}) format('opentype');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextBold}) format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextBoldItalic}) format('opentype');
    font-weight: 700;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextHeavy}) format('opentype');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextHeavyItalic}) format('opentype');
    font-weight: 800;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextBlack}) format('opentype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'DIN Next LT Pro';
    src: url(${DINNextBlackItalic}) format('opentype');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
  }
`

export default MladinskaFonts
